import {ADDFOLDER, FETCHFOLDER} from '../Actions/types';
import {API_ADDR} from '../DatabaseStrings/dbStrings';
import auth from '../Authentication/auth'

export const Addfolder = (objName, value) => dispatch => {
    dispatch({
        type: ADDFOLDER,
        payload: value,
        objName: objName
    });
}

export const fetchfolder = () => async (dispatch) =>{
    console.log("folder action")
    fetch(`${API_ADDR}/api/Folder`,
         {  
            mode:'cors',
            credentials:'include',
            referrerPolicy:'strict-origin-when-cross-origin',
            headers:{
            Authorization: `Bearer ${auth.getToken()}`,
            'Accept': 'application/json',
                
             }
         }).then(res =>res.json())
         .then(data => dispatch({
            type:FETCHFOLDER, 
            payload: data
            
        })).catch(err => console.error(err))
}

